import React from 'react';

import { studioTheme } from './studioTheme';
import {
  StudioWrap,
  Avatar,
  Identity,
  SourceLogo,
  Stars,
  DateText,
  Engagement,
} from './StudioCardKit';
import { StudioBody, isMediaTestimonial, StudioMediaCard } from './StudioBody';

/**
 * Topline (widget type 13)
 *
 * The tidy review-site shape: rating sits on the top line beside the person,
 * the quote gets the middle, and the meta rail at the foot carries the
 * engagement it came with, the source platform and the date.
 */
const ToplineCard = (props) => {
  const { cardItem, socialCardType } = props;
  const t = studioTheme(props);

  /* One body type scale per card: the text testimonial and the video/audio
     summary must read as the same widget. */
  const bodyTextStyle = { fontSize: t.smallSize ? 14 : 14.5, lineHeight: 1.55 };

  /* A video or audio testimonial IS the card - the player already carries
     the name and work title, so none of the chrome below is drawn. Only the
     summary keeps this widget's look, as the panel it extends into. */
  if (isMediaTestimonial(cardItem, socialCardType)) {
    return (
      <StudioMediaCard
        cardItem={cardItem}
        socialCardType={socialCardType}
        t={t}
        enclosure={{
          border: `1px solid ${t.line}`,
          borderRadius: 16,
          background: t.surface,
          /* the wall's custom card colour wins, as it does on the text card */
          ...(t.cardBackgroundObject || {}),
          boxShadow: t.shadow,
        }}
        summaryStyle={bodyTextStyle}
      />
    );
  }

  return (
    <StudioWrap>
      <div
        style={{
          position: 'relative',
          borderRadius: 16,
          padding: 18,
          display: 'flex',
          flexDirection: 'column',
          gap: 12,
          border: `1px solid ${t.line}`,
          background: t.surface,
          ...(t.cardBackgroundObject || {}),
          boxShadow: t.shadow,
        }}
      >

        <div style={{ display: 'flex', alignItems: 'center', gap: 10, minWidth: 0 }}>
          <Avatar cardItem={cardItem} size={40} />
          <div style={{ flex: 1, minWidth: 0 }}>
            <Identity t={t} cardItem={cardItem} />
          </div>
          <SourceLogo cardItem={cardItem} />
        </div>

        <Stars t={t} cardItem={cardItem} size={13} />

        <StudioBody
          t={t}
          cardItem={cardItem}
          socialCardType={socialCardType}
          textStyle={bodyTextStyle}
        />

        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 10,
            flexWrap: 'wrap',
            borderTop: `1px solid ${t.line}`,
            paddingTop: 10,
          }}
        >
          <span style={{ display: 'inline-flex', alignItems: 'center', gap: 10, minWidth: 0 }}>
            <Engagement t={t} cardItem={cardItem} />
          </span>
          <DateText t={t} cardItem={cardItem} />
        </div>
      </div>
    </StudioWrap>
  );
};

export default ToplineCard;
